// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JHxTa","content":"styles_content__1w-iP","row":"styles_row__3JB4B","footer":"styles_footer__1fp-N","phraseLength":"styles_phraseLength__23lFN"};